// extracted by mini-css-extract-plugin
export var messageSideLeft = "_my-1";
export var messageSideRight = "_my-2";
export var orderLookupBubbleContainer = "_my-0";
export var submitButton = "_my-3";